import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import FamilyHome from "./FamilyHome";
import FamilyHomeV2 from "./FamilyHomeV2";

// V2's hero (greeting beside the member chips) and two-up tabs need the width to
// read well; below this the mobile-first v1 home is the better layout. Matches
// the breakpoint newLogin.css already uses to stack its two panes.
const MOBILE_QUERY = "(max-width: 768px)";

const FamilyHomeResponsive = () => {
  // noSsr evaluates the query during mount instead of after, so mobile users
  // never see a frame of the desktop layout before it swaps.
  const isMobile = useMediaQuery(MOBILE_QUERY, { noSsr: true });

  return isMobile ? <FamilyHome /> : <FamilyHomeV2 />;
};

export default FamilyHomeResponsive;
